// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__lo761","card":"Contact_card__65bmm"};